import React, { useState, useCallback } from 'react';
import Contracts from './index';

const ContractsContainer = () => {
  const [viewMode, setViewMode] = useState<'list' | 'grid'>('list');
  
  const handleViewSwitch = useCallback((view: 'list' | 'grid') => {
    setViewMode(view);
  }, []);

  return (
    <Contracts onViewSwitch={handleViewSwitch} />
  );
};

export default ContractsContainer;
